import useJwt from './useJwt';

export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName);
};

// export const getUserData = () => JSON.parse(localStorage.getItem('userData'));
